document.addEventListener('DOMContentLoaded', function () {
  initClickAttribute()
  closeCardCompares()
  initAnimatedSvg()
  inputMaskCustom()
  initLogin()
  openAuth()

  initinterregional()

  initMainNav()
  initSwiper()
  initFancyBox()
  initBasket()
  initTabs()
  initFormValidation()
  initPlaceholder()
  initTextOverflowHidden()
  initAnimationCounter()
  initMenu()
  initMainCatalog()
  initDropDown()
  initOpenCloseCard()
  initCardBuy()
  initAccordionSlider()
  initAddModifation()
  initProductFilter()
  initProfile()
  initDragDrop()
  initInputEye()
  initPopupsClearDN()
  popupCheck()
  cardCounter()
  initRangeSlider()
  initMgBurger()
  mgCheckStatus()
  mgSlideUpDown()
  mgCheckSucess()

  // Fortuna caller
  autoCallerFortunaModal()

  // yMap()
  validationSocial()
  mgCategory()
  mgPortfolio()
  mgPortfolioChecke()
  initOrdering()
  popupPersonalData()
  openP()
  raffle()
  reff()

  validateComplains()

  paEmployee()

  editEmployee()

  lazyLoadImg()

  initPulseCardProduct()

  complainsDnD()

  textOpen()

  bigSliderOpen()

  newsOpen()

  closePopup()

  // initBonusRange()

  // initBonusStatistick()

  // showCallbackFrom()






  // rating()
  // initOpenClose();
  // initActiveSelectResize()
  // mgCrop();
  // toggleAccordion();
  // initCounter();
  // initSelectCity();
  // initSearch();
  //mgAnchor();
  // popupSlide();
  // popupSelect();
  // popupCounter();
  // popupTotal();
  // document.querySelectorAll("[style='display: none']").forEach(el => el.removeAttribute('style'))

  $.fancybox.defaults.btnTpl.share = false
})

